import * as React from 'react';
import { Route } from "react-router";

import { SaveSettingsFn, GetSettingsFn } from "../../../rest/settings";

import { Modal } from "../../../components/Modal/Modal";
import { TwoButtonDialog } from "../Dialogs/TwoButtonDialog";

import { SettingsView } from "./SettingsView";
import { Container } from "../../Container";
import { SettingsStore } from "./SettingsStore";
import { SettingsActions } from "./SettingsActions";
import { CurrentDivisionStore } from "../DivisionPath/flux/CurrentDivisionStore";
import { FlagStore } from "../../flux/Flag/FlagStore";
import { ErrorStore } from "../../flux/Error/ErrorStore";
import { twoButtonDialogConfig } from "../../utils/configure-store";
import { Polyglot } from '../../../polyglot';
import { appNavigator } from "../../routes";
import { Command } from "../../../Command";

interface Props
{
    polyglot: Polyglot;
    currentDivisionStore: CurrentDivisionStore;

    inProgressStore: FlagStore;
    errorStore: ErrorStore;    
    
    settingsStore: SettingsStore;
    initSettingsCommand: Command;
    saveSettingsCommand: Command;

    isEmailNotificationEnabled: boolean;
    isAdmin: boolean;
}

// Settings components is container arround SettingsView with Save Cancel buttons
export class Settings extends React.Component<Props>
{
    private readonly actions = new SettingsActions();

    render()
    {
        const division = this.props.currentDivisionStore.getCurrentDivision();
        const { isAdmin } = this.props;
        return (
            <Modal>
                <Container merge stores={twoButtonDialogConfig(this.props.inProgressStore, this.props.errorStore)}>
                    <TwoButtonDialog
                        okTitle={this.props.polyglot.t('button.save')}
                        cancelTitle={this.props.polyglot.t('button.cancel')}
                        ok={this.props.saveSettingsCommand.execute}
                        cancel={appNavigator.closeSettings} >
                        <Container
                            actions={this.actions}
                            store={this.props.settingsStore}
                            onMount={() => this.props.initSettingsCommand.execute()}
                        >
                            <SettingsView
                                polyglot={this.props.polyglot}
                                division={null} setDivision={null}
                                quantities={null} quantitySettings={null} setQuantityUnit={null}
                                emails={null} setEmails={null}
                                languages={null} selectedLanguage={null} setLanguage={null}
                                passwordFlag={false} setChangePasswordFlag={null}
                                password={''} setPassword={null}
                                passwordConfirmation={''} setPasswordConfirmation={null}
                                isEmailNotificationEnabled={this.props.isEmailNotificationEnabled}
                                dontAlertLeavingRedZone={null}  setDontAlertLeavingRedZone={null}
                                dontAlertEnteringYellowZone={null} setDontAlertEnteringYellowZone={null}
                                dontAlertLeavingYellowZone={null} setDontAlertLeavingYellowZone={null}
                                isAdmin={isAdmin}
                            />
                        </Container>
                    </TwoButtonDialog>
                </Container>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Settings/Settings.tsx